// Injury Details Component
// Displays injury information and treatment details

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Stethoscope } from 'lucide-react';

const InjuryDetails = ({ intake }) => {
  return (
    <Card className="border-slate-200" data-testid="injury-details-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg" style={{ fontFamily: 'Manrope, sans-serif' }}>
          <Stethoscope className="w-5 h-5 text-slate-600" />
          Injury &amp; Treatment
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Injured</p>
          <p className="text-slate-900 font-medium">{intake.injured ? 'Yes' : 'No'}</p>
        </div>
        {intake.injury_description && (
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Injury Description</p>
            <p className="text-slate-700">{intake.injury_description}</p>
          </div>
        )}
        <Separator />
        <div>
          <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Medical Treatment</p>
          <p className="text-slate-900 font-medium">{intake.medical_treatment ? 'Yes' : 'No'}</p>
        </div>
        {intake.treatment_details && (
          <div>
            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Treatment Details</p>
            <p className="text-slate-700">{intake.treatment_details}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default InjuryDetails;
